import React from "react";
import clsx from "clsx";
import { Link } from "react-router-dom";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import Drawer from "@material-ui/core/Drawer";
import Box from "@material-ui/core/Box";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import List from "@material-ui/core/List";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import Container from "@material-ui/core/Container";
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ListSubheader from "@material-ui/core/ListSubheader";
import logo from "assets/images/logo.png";
import CircularProgress from "@material-ui/core/CircularProgress";
import { withRouter } from "react-router";
import { message } from "constants/message";

import { 
  Button, 
  Tooltip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@material-ui/core";
import {
  HeadsetMic,
  Group,
  Assignment,
  Dvr,
  Notifications,
  Notes,
  Mail,
  ContactMail,
  Info,
} from "@material-ui/icons";
import Copyright from "../../Components/Copyright";
import useAuth from "Hooks/Admin/useAuth";
import useApi from "Hooks/Admin/useApi";

import AdminLogout from "../../Components/AdminLogout";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  toolbar: {
    paddingRight: 24,
  },
  toolbarIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "0 8px",
    ...theme.mixins.toolbar,
  },
  userName: {
    display: "inherit",
    alignItems: "center",
    fontSize: "15px",
  },
  appBar: {
    position: "fixed",
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: "none",
  },
  title: {
    flexGrow: 1,
  },
  logoImage: {
    width: "140px" ,
    cursor: "pointer",
  },
  drawerPaper: {
    position: "fixed",
    whiteSpace: "nowrap",
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    overflow: "hidden",
  },
  drawerPaperClose: {
    overflowX: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
  },
  container: {
    [theme.breakpoints.down('xl')]: {
      maxWidth: "1285px",
    },
    [theme.breakpoints.up('xl')]: {
      maxWidth: "95%",
    },
    paddingLeft: drawerWidth,
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  containerShift: {
    paddingLeft: theme.spacing(7),
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  groupName: {
    fontWeight: "bold",
    fontSize: "18px",
  },
  loading: {
    position: "fixed",
    zIndex: 111111,
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#000",
    opacity: 0.3,
  },
  menuList: {
    height: "90%",
    overflowX: "hidden",
  },
  menuListClose: {
    height: "90%",
    overflow: "hidden",
  },
  hideMenu: {
    display: "flex",
    alignItems: "center",
    padding: "16px",
    cursor: "pointer",
  },
  menuIcon: {
    minWidth: "45px",
  }
}));

const LinkedListSubheader = withStyles(() => ({
  sticky: {
    cursor: "pointer",
  },
}))(ListSubheader);
const ActiveListSubheader = withStyles((theme) => ({
  sticky: {
    backgroundColor: theme.palette.primary.main,
    color: "#FFF",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
}))(ListSubheader);

function ListItemLink(props) {
  return <ListItem button component={Link} disabled={1 == props.isdisable} {...props} />;
}

function Layout(props) {
  // const { state } = useAuth();
  const auth = useAuth();
  const { request } = useApi();
  const api = useApi();
  const messages = message();

  const classes = useStyles();
  const [open, setOpen] = React.useState(true);
  const [logoutOpen, setLogoutOpen] = React.useState(false);
  const [isShowErrorModal, setIsShowErrorModal] = React.useState(false);
  const [userName, setUserName] = React.useState("");
  // グローバルメニューの表示制限
  const [canShowAdministrator, setCanShowAdministrator] = React.useState(false);
  const [canShowAccount, setCanShowAccount] = React.useState(false);
  const [canShowCsvDownload, setCanShowCsvDownload] = React.useState(false);
  const [canShowCustomerScreen, setCanShowCustomerScreen] = React.useState(false);
  const [canShowInformation, setCanShowInformation] = React.useState(false);
  const [canShowDtm, setCanShowDtm] = React.useState(false);
  const [canShowDtmSetting, setCanShowDtmSetting] = React.useState(false);
  const [canShowInformationUrls, setCanShowInformationUrls] = React.useState(false);
  const [canShowMediaAccounts, setCanShowMediaAccounts] = React.useState(false);
  const [canShowMediaCategories, setCanShowMediaCategories] = React.useState(false);
  const [canShowLog, setCanShowLog] = React.useState(false);

  React.useEffect(() => {
    const adminToken = localStorage.getItem("admintoken");
    if (!adminToken || adminToken === null) {
      props.history.push("/admin/?status=401");
      return;
    }

    setUserName(JSON.parse(localStorage.getItem("adminuser")).name);

    auth.login({
      token: adminToken,
      user: JSON.parse(localStorage.getItem("adminuser")),
      features: localStorage.getItem("features"),
    });

    const features = (localStorage.getItem("features")).split(',');

    features.forEach( feature => {
      switch (feature) {
        case "10":
          setCanShowAdministrator(true);
          break;
        case "20":
          setCanShowAccount(true);
          break;
        case "30":
          setCanShowCsvDownload(true);
          break;
        case "40":
          setCanShowCustomerScreen(true);
          break;
        case "50":
          setCanShowInformation(true);
          break;
        case "60":
          setCanShowInformationUrls(true);
          break;
        case "70":
          setCanShowDtm(true);
          break;
        case "80":
          setCanShowDtmSetting(true);
          break;
        case "90":
          setCanShowMediaAccounts(true);
          break;
        case "95":
          setCanShowMediaCategories(true);
          break;
        case "9999":
          setCanShowLog(true);
          break;
      }
    })
  }, []);

  React.useEffect(() => {
    if (!auth.state.token || auth.state.contracts) {
      return;
    }
    request({
      method: "GET",
      url: "admin/contracts",
    }).then((result) => {
      auth.setContracts(result.data.data);
    });
  }, [auth.state.token]);

  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleLogoutOpen = () => {
    setLogoutOpen(true);
  };

  const handleLogoutClose = () => {
    setLogoutOpen(false);
  };

  const handleClickLogo = () => {
    props.history.push("/admin/top");
  };

  return (
    <div className={classes.root}>
      {api.state.isFetch && (
        <div className={classes.loading}>
          <CircularProgress color="secondary" />
        </div>
      )}
      <AdminLogout logoutOpen={logoutOpen} handleLogoutClose={handleLogoutClose} />
      <CssBaseline />
      <AppBar
        position="absolute"
        className={classes.appBar}
      >
        <Toolbar className={classes.toolbar}>
          <Typography
            component="h1"
            variant="h6"
            color="inherit"
            noWrap
            className={classes.title}
            onClick={handleClickLogo}
          >
            <img src={logo} className={classes.logoImage}/>
          </Typography>

          <Typography
            color="inherit"
            noWrap
            className={classes.userName}
          >
            <AccountCircleIcon /> {userName}
          </Typography>
          <Button color="inherit" onClick={() => handleLogoutOpen(true)}>
            ログアウト
          </Button>
        </Toolbar>
      </AppBar>
      <Drawer
        variant="permanent"
        classes={{
          paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose),
        }}
        open={open}
      >
        <div className={classes.toolbarIcon}>
          <IconButton onClick={handleDrawerClose}>
            <ChevronLeftIcon />
          </IconButton>
        </div>
        <Divider />
        <List 
          id="menuList"
          className={open ? classes.menuList : classes.menuListClose}
        >
          {canShowAdministrator && (
            <ListItemLink to="/admin/administrator" isdisable={0}>
              <ListItemIcon className={classes.menuIcon}>
                <HeadsetMic />
              </ListItemIcon>
              <ListItemText primary="管理者管理" />
            </ListItemLink>
          )}
          {canShowAccount && (
            <ListItemLink to="/admin/account">
              <ListItemIcon className={classes.menuIcon}>
                <Group />
              </ListItemIcon>
              <ListItemText primary="アカウント管理" />
            </ListItemLink>
          )}
          {canShowCsvDownload && (
            <ListItemLink to="/admin/csv_download">
              <ListItemIcon className={classes.menuIcon}>
                <Assignment />
              </ListItemIcon>
              <ListItemText primary="CSVダウンロード" />
            </ListItemLink>
          )}
          {canShowCustomerScreen && (
            <ListItemLink to="/admin/customerScreen">
              <ListItemIcon className={classes.menuIcon}>
                <Dvr />
              </ListItemIcon>
              <ListItemText primary="顧客データ調査" />
            </ListItemLink>
          )}
          {canShowInformation && (
            <ListItemLink to="/admin/information">
              <ListItemIcon className={classes.menuIcon}>
                <Info />
              </ListItemIcon>
              <ListItemText primary="お知らせ管理" />
            </ListItemLink>
          )}
          {canShowDtm && (
            <ListItemLink to="/admin/dtm">
              <ListItemIcon className={classes.menuIcon}>
                <Mail />
              </ListItemIcon>
              <ListItemText primary="DTM告知管理" />
            </ListItemLink>
          )}
          {canShowDtmSetting && (
            <ListItemLink to="/admin/dtm/settings">
              <ListItemIcon className={classes.menuIcon}>
                <ContactMail />
              </ListItemIcon>
              <ListItemText primary="DTM告知一括設定" />
            </ListItemLink>
          )}
          {canShowInformationUrls && (
            <ListItemLink to="/admin/informationUrls">
              <ListItemIcon className={classes.menuIcon}>
                <Notifications />
              </ListItemIcon>
              <ListItemText primary="ヘッダー告知管理" />
            </ListItemLink>
          )}
          {canShowLog && (
            <ListItemLink to="/admin/log">
              <ListItemIcon className={classes.menuIcon}>
                <Notes />
              </ListItemIcon>
              <ListItemText primary="操作ログ" />
            </ListItemLink>
          )}
          {canShowMediaAccounts && (
            <ListItemLink to="/admin/media/accounts">
              <ListItemIcon className={classes.menuIcon}>
                <Notes />
              </ListItemIcon>
              <ListItemText primary="【多メディア】" secondary="収集グループ管理" />
            </ListItemLink>
          )}
          {canShowMediaCategories && (
            <ListItemLink to="/admin/media/types">
              <ListItemIcon className={classes.menuIcon}>
                <Notes />
              </ListItemIcon>
              <ListItemText primary="【多メディア】" secondary="メディア管理" />
            </ListItemLink>
          )}
        </List>
        <div 
          className={classes.hideMenu}
          onClick={open ? handleDrawerClose : handleDrawerOpen}
        >
          <ListItemIcon>
            {open ? (<ChevronLeftIcon />) : (<ChevronRightIcon />)}
          </ListItemIcon>
          <ListItemText primary="メニューを隠す" />
        </div>
      </Drawer>
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container className={
          clsx(classes.container, !open && classes.containerShift)
        }>
          {props.content}
          <Box pt={4}>
            <Copyright />
          </Box>
        </Container>
      </main>
      <Dialog open={isShowErrorModal} 
        onClose={() => setIsShowErrorModal(false)}
      >
        <DialogContent>
          <DialogContentText>
            {messages.errorMsg.getManualErr}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color="primary" onClick={() => setIsShowErrorModal(false)}>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default withRouter(Layout);
